export type LocalizedString = {
	[key: string]: string
}
